import { render, staticRenderFns } from "./PhotoReview.vue?vue&type=template&id=ed1d9684&scoped=true"
import script from "./PhotoReview.vue?vue&type=script&lang=js"
export * from "./PhotoReview.vue?vue&type=script&lang=js"
import style0 from "./PhotoReview.vue?vue&type=style&index=0&id=ed1d9684&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed1d9684",
  null
  
)

export default component.exports